import './Video.css';
import VideoPlayer from './VideoPlayer';
import videoAbout from '../assets/video-about.mp4';


export default function Video() {
    return(
        <section className='mx-auto py-16 px-[20px] sm:px-[100px] lg:px-[200px]' id='video-section'>
            <div className='w-full items-center justify-center m-auto'>
                <VideoPlayer videoMaterial={videoAbout}/>
            </div>
        </section>
    );
}